/* eslint-disable max-lines-per-function */
const reducer = (state: any, action: any) => {
  const { type, data } = action;

  switch (type) {
    case 'SET_TITLE':
      return {
        ...state,
        productFormData: {
          ...state.productFormData,
          title: data,
        },
      };
    case 'SET_REVIEW':
      return {
        ...state,
        productFormData: {
          ...state.productFormData,
          text: data,
        },
      };
    case 'SET_TROUBLE_TYPE':
      return {
        ...state,
        productFormData: {
          ...state.productFormData,
          trouble: {
            ...state?.productFormData?.trouble,
            type: data,
          },
        },
      };
    case 'SET_TROUBLE_DESCRIPTION':
      return {
        ...state,
        productFormData: {
          ...state.productFormData,
          trouble: {
            ...state?.productFormData?.trouble,
            description: data,
          },
        },
      };
    case 'SET_RATING':
      return {
        ...state,
        productFormData: {
          ...state.productFormData,
          rating: data,
        },
      };
    case 'SET_TAGS':
      return {
        ...state,
        productFormData: {
          ...state.productFormData,
          tags: [...data],
        },
      };
    case 'SET_WITHOUT_TROUBLE':
      return {
        ...state,
        productFormData: {
          ...state.productFormData,
          withoutTrouble: data,
        },
      };
    case 'SET_PRODUCT_IMAGE':
      return {
        ...state,
        product: {
          ...state.product,
          images: [{ medium: data }],
        },
      };
    case 'SET_SKU_ID':
      return {
        ...state,
        urlData: {
          ...state.urlData,
          skuId: data,
        },
      };
    default:
      throw new Error('Reducer says: Action type not found');
  }
};

export default reducer;
export { reducer };
